


























import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { CompanyUserDto } from '@/dto/company-user/company-user.dto';
import companyUserService from '@/services/company-user.service';
import CardWithTitle from '@/modules/_common/components/CardWithTitle.vue';
import { BaseUser } from '../../../services/shared/auth';
import { COMPANY_USER, CONST_COMPANY_USER } from '@/services/shared';
@Component({
  name: 'UserDetail',
  components: { CardWithTitle },
})
export default class UserDetail extends BaseComponent {
  private companyUserDto = new CompanyUserDto(BaseUser);
  private companyUserAdminRole: COMPANY_USER[] = [...CONST_COMPANY_USER];
  getUser() {
    companyUserService.findOne(this.$route.params.id).subscribe(res => {
      this.companyUserDto = res.data;
    });
  }
  created() {
    this.getUser();
  }
}
